import type { CalculateGrossSalaryParams } from "./types";
import type { VariantCalculations } from "@/types/salary";
import { DEFAULT_LAW_YEAR } from "@/constants/salary";
import { NetSalaryGoalSeek } from "../net-salary-goal-seek";

const calculateGrossSalary = ({
    netSalary,
    insuranceWage,
    bonus = [],
    deduction = [],
    lawYear = DEFAULT_LAW_YEAR,
}: CalculateGrossSalaryParams): [number, VariantCalculations] => {
    const netSalaryGoalSeek = new NetSalaryGoalSeek();

    const [grossSalary, variantCalculations] = netSalaryGoalSeek.seek(
        netSalary,
        {
            insuranceWage,
            bonus,
            deduction,
            lawYear,
        }
    );

    return [grossSalary, variantCalculations];
};

export { calculateGrossSalary };
export type { CalculateGrossSalaryParams };
